// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.main[data-v-38161840] {\n  background: white;\n}\n.error[data-v-38161840] {\n  color: red;\n}\n.info[data-v-38161840] {\n  color: black;\n}\n.header[data-v-38161840] {\n  font-weight: bold;\n}\n.item[data-v-38161840] {\n  display: list-item;\n  margin-left: 2em;\n}\nh5[data-v-38161840] {\n  background: rgb(230,230,255);\n  margin: 1em 0;\n  padding: 0.5em;\n}\n", ""]);
// Exports
module.exports = exports;
